import { mapState, mapActions } from 'vuex'
// import viewName from '../constant.js'
import { Swipe, SwipeItem } from 'vant'
import QualityImg from '@/components/qualityImg/qualityImg.vue'

export default {
    name: 'Swiper',
    components: {
        Swipe,
        SwipeItem,
        QualityImg
    },
    data () {
        return {
            current: 0,
            images: [
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg'
            ]
        }
    },
    props: {
        imgs: {
            type: Array,
            default: []
        },
        isShowSkuPic: {
            type: Boolean,
            default: false
        },
        actSrc: {
            type: String,
            default: ''
        }
    },
    watch: {
        imgs (newValue) {
            // 数据源发生变化时，指定从第一张图片开始
            this.$refs.swipe.swipeTo(0)
        }
    },
    computed: {
        ...mapState({}),
        // 是否有视频，有就终止自动轮播
        getHasVideo () {
            return this.imgs.some(item => item.indexOf('mp4') > -1)
        }
    },
    created () {},
    activated () {},
    mounted () {},
    methods: {
        ...mapActions([]),

        onChange (index) {
            this.current = index
            if (this.imgs[index].indexOf('mp4') === -1) {
                this.$refs.video && this.$refs.video[0].pause()
            } else {
                if (!this.$refs.video[0].paused) {
                    this.$refs.video[0].play()
                }
            }
        }
    },
    destroyed () {}
}
